import React from 'react';

import classNames from 'classnames';
import styles from './Icons.module.scss';

export const IconClose = ({ className, ...props }) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={classNames(className, styles.svg)} {...props}>
        <path fillRule="evenodd" clipRule="evenodd" d="M24.0473 1.39098L22.6532 0L12.0237 10.609L1.39414 0L0 1.39098L10.6295 12L0 22.609L1.39414 24L12.0237 13.391L22.6532 24L24.0473 22.609L13.4162 12L24.0473 1.39098Z" fill="white"/>
    </svg>
);

